var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1779 8.18309C16.1779 7.61587 16.127 7.07046 16.0325 6.54688H8.49792V9.64113H12.8034C12.6179 10.641 12.0543 11.4882 11.207 12.0555V14.0625H13.7925C15.3052 12.6699 16.1779 10.6192 16.1779 8.18309Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50053 15.9989C10.6605 15.9989 12.4714 15.2826 13.7951 14.0609L11.2096 12.0538C10.4933 12.5338 9.5769 12.8174 8.50053 12.8174C6.4169 12.8174 4.65326 11.4103 4.02417 9.51953H1.35144V11.5921C2.6678 14.2064 5.37326 15.9989 8.50053 15.9989Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02364 9.5185C3.86364 9.03855 3.77273 8.52587 3.77273 7.99865C3.77273 7.47142 3.86364 6.95874 4.02364 6.47879V4.40625H1.35091C0.809091 5.48615 0.5 6.70786 0.5 7.99865C0.5 9.28943 0.809091 10.5111 1.35091 11.591L4.02364 9.5185Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50041 3.18152C9.67496 3.18152 10.7295 3.58512 11.5586 4.37778L13.8531 2.08344C12.4677 0.792654 10.6568 0 8.50041 0C5.37314 0 2.66768 1.79256 1.35132 4.40687L4.02405 6.4794C4.65314 4.58867 6.41677 3.18152 8.50041 3.18152Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.21a13b11f5d177dd3055ca7908de4ce9.svg";
export { ForwardRef as ReactComponent };